
import { useState, useEffect } from 'react';

const EDGE_FUNCTION_URL = `https://nkrxgmguwqkczuphqcvu.functions.supabase.co/get-mapbox-token`;

export const useMapboxToken = () => {
  const [mapboxToken, setMapboxToken] = useState<string | null>(null);
  const [loadingToken, setLoadingToken] = useState(true);
  const [tokenError, setTokenError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchToken() {
      setLoadingToken(true);
      setTokenError(null);
      
      try {
        const res = await fetch(EDGE_FUNCTION_URL, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          }
        });

        
        if (!res.ok) {
          const errText = await res.text();
          console.error('🗺️ Token fetch failed:', errText);
          throw new Error(`Failed to load Mapbox token: ${res.status} ${res.statusText}`);
        }
        
        const data = await res.json();
        if (!cancelled && data.token) {
          setMapboxToken(data.token);
          setLoadingToken(false);
        } else if (!data.token) {
          throw new Error('No token received from server');
        }
      } catch (e: any) {
        console.error('🗺️ Token fetch error:', e);
        if (!cancelled) {
          setTokenError(e.message || "Failed to fetch Mapbox token");
          setLoadingToken(false);
        }
      }
    }

    fetchToken();

    return () => {
      cancelled = true;
    };
  }, []);

  return { mapboxToken, loadingToken, tokenError };
};
